import { combineEpics } from "redux-observable";
import eventsListEpic from "./eventList/eventList.epic";
import viewEventEpic from "./viewEvent/viewEvent.epic";

const eventsEpic = combineEpics(eventsListEpic, viewEventEpic);

export default eventsEpic;
